export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
export const HIDE_SIDEBAR = "HIDE_SIDEBAR";
export const HIDE_SIDEBAR_AND_CLEAR_DATA = "HIDE_SIDEBAR_AND_CLEAR_DATA";
export const RESET_NOTIFICATIONS = "RESET_NOTIFICATIONS";
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const FETCH_NOTIFICATIONS_FAILED = "FETCH_NOTIFICATIONS_FAILED";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";